import { Component, OnInit, EventEmitter } from '@angular/core';
import { PurchaseOrderService } from '../../services/purchase-order.service';
import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { Utils } from '../../util';
import { MaterializeAction, toast } from 'angular2-materialize';
import { PermissionService, SpecialPermissions } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-purchase-report',
  templateUrl: './purchase-report.component.html',
  styleUrls: ['./purchase-report.component.css']
})
export class PurchaseReportComponent implements OnInit {
  allowed: boolean = false;
  permission: Partial<{[K in keyof typeof SpecialPermissions]: boolean}> = {};

  rows: any[] = [];
  filteredRows: any[] = [];

  initial: string = '';
  final: string = this.today;

  supplierSelect: string[];
  
  pickadateParams = Utils.pickadateParams();

  constructor(
    private service: PurchaseOrderService,
    private supplierService: CustomerSupplierService,
		private permissionService: PermissionService,
    private authService: AuthService,
    private router: Router,
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
        permissionsSubs.unsubscribe();
        this.permission = this.permissionService.constructPermissionObject(groups, 'SPECIAL');
        if(!this.permission || !this.permission.purchaseReport){
          toast('No tiene permisos.', 3000);
          this.router.navigate(['/']);
        }
        else this.allowed = true;
    });
    /* let supplierSub = this.supplierService.getSuppliers().subscribe(suppliers => {
      supplierSub.unsubscribe();
      //this.supplierSelect = suppliers.map(({name}) => name ).sort((n1, n2) => n1 > n2 ? 1 : -1);
    }); */
  }

  ngOnInit(){
  }

  getOrders(){
    this.supplierSelect = undefined;
    let sub = this.service.getPurchaseOrders({date: this.initial}).subscribe(orders => {
      let obj = orders.filter(({date}) => date <= this.final).reduce((acc, cur) => {
        let supName = cur.supplierObj.name;
        if(!acc[supName]) acc[supName] = { supplier: supName, subTotal: 0, ivaTotal: 0, total: 0, orders: [] };
        acc[supName].subTotal += cur.subTotal;
        acc[supName].ivaTotal += cur.ivaTotal;
        acc[supName].total += cur.total;
        acc[supName].orders.push(cur);
        return acc;
      }, {});
      this.supplierSelect = Object.keys(obj);
      this.rows = this.supplierSelect.reduce((acc, cur) => [ obj[cur], ...acc ], [] );
      this.filterRows();
    });
  }

  filterRows(name=''){
    this.filteredRows = this.rows.filter(({supplier}) => supplier == name || !name);
  }
  get totals(){
    return this.filteredRows.reduce((acc, cur) => ({
      label: 'Total',
      subTotal: acc.subTotal + cur.subTotal,
      ivaTotal: acc.ivaTotal + cur.ivaTotal,
      total: acc.total + cur.total,
    }), {subTotal: 0, ivaTotal: 0, total: 0} )
  }

  onCSV(){
    let rows = [
      {l1: 'Proveedor', l2: 'Monto sin iva', l3: 'Iva', l4: 'Monto con iva', },
      ...this.filteredRows.map(({orders, ...row}) => row),
      this.totals
    ]
    let csv = Utils.objectArrayToCSV(rows);
    var encodedUri = encodeURI(csv);
    var link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "reporte.csv");
    document.body.appendChild(link); // Required for FF

    link.click();
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////Show
  modalActionsShow = new EventEmitter<string|MaterializeAction>();
  modalParamsShow = [{dismissible: true}];

  currentShowIndex: number = -1;

  openModalShow(index: number) {
    this.currentShowIndex = index;
    this.modalActionsShow.emit({ action: 'modal', params: ['open'] });
  }
  closeModalShow() {
    this.modalActionsShow.emit({ action: 'modal', params: ['close'] });
  }
  /////////////////////////////////////////////////////////////////////////////////////////////////////Show

  get today(){
    return this.stringifyDate(new Date());
  }
  stringifyDate(date: Date){
    var dd:string = date.getDate() + '';
    var mm:string = date.getMonth()+ 1 + '';
    var yyyy = date.getFullYear();
    if(+dd<10) dd = '0'+dd;
    if(+mm<10) mm = '0'+mm;
    return yyyy + '-' + mm + '-' + dd;
  } 
  money = Utils.money;
}
